import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-goals-headerbar',
  templateUrl: './goals-headerbar.component.html',
  styleUrls: ['./goals-headerbar.component.css']
})
export class GoalsHeaderbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
